import { injectScript } from '../../utils/script';
const gtag = () => window.gtag;
export const gtagTracker = ({ trackingId }) => ({
    name: 'gtag',
    initBrowser() {
        const script = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        const w = window;
        w.dataLayer = w.dataLayer || [];
        w.gtag = function gtag() {
            w.dataLayer.push(arguments);
        };
        w.gtag('js', new Date());
        gtag()('config', trackingId, {
            send_page_view: false
        });
        injectScript({ src: script });
        gtag();
    },
    trackProduct({ quantity, action, product, selectedVariation, list, index }) {
        const productData = {
            id: product.id,
            name: product.name,
            variant: selectedVariation
                ? selectedVariation.articleNumber
                : product.articleNumber,
            base_product: product.articleNumber,
            quantity,
            price: (selectedVariation && selectedVariation.price.incVat) ||
                (product.price && product.price.incVat),
            category: product.canonicalCategory && product.canonicalCategory.name,
            list_name: list,
            list_position: index
        };
        switch (action) {
            case 'click':
                gtag()('event', 'select_content', {
                    content_type: 'product',
                    items: [productData]
                });
                break;
            case 'view':
                gtag()('event', 'view_item', {
                    items: [productData],
                    non_interaction: true
                });
                break;
            case 'add':
                gtag()('event', 'add_to_cart', { items: [productData] });
                break;
            case 'remove':
                gtag()('event', 'remove_from_cart', { items: [productData] });
                break;
            default:
                console.log('Error: Gtag can not track action ' + action);
                break;
        }
    },
    trackCartCheckout({ cart }) {
        gtag()('event', 'begin_checkout', {
            items: cart.items.map(item => ({
                id: item.product.id,
                name: item.product.name,
                category: item.product.canonicalCategory && item.product.canonicalCategory.name,
                price: item.total.incVat,
                quantity: item.quantity
            }))
        });
    },
    trackPageView({ pathname }) {
        gtag()('event', 'page_view', { page_path: pathname });
    },
    trackList({ listName, products }) {
        const productData = products.map((product, i) => ({
            id: product.id,
            name: product.name,
            category: product.canonicalCategory && product.canonicalCategory.name,
            price: product.price && product.price.incVat,
            list_name: listName,
            list_position: i
        }));
        gtag()('event', 'view_item_list', {
            items: productData,
            non_interaction: true
        });
    }
});
//# sourceMappingURL=gtag.js.map